import styled from 'styled-components';

export const StyledMessagesContainer = styled.div`
  position: relative;
  padding: ${({ theme }) =>
    `${theme.spacing.md} ${theme.spacing['2Xl']} 0 ${theme.spacing['2Xl']}`};
`;

export const StyledMessagesContent = styled.div``;

export const StyledMessageWrapper = styled.div<{
  $extensionType?: string | null;
  $isMessageComboTimestamp?: boolean;
}>`
  margin-bottom: ${({ $extensionType, $isMessageComboTimestamp, theme }) =>
    $extensionType === 'text' && !$isMessageComboTimestamp
      ? theme.spacing['md']
      : theme.spacing['2Xl']};

  :last-of-type {
    margin-bottom: 0;
  }
`;

export const StyledAuthorHeader = styled.div`
  display: flex;
  height: ${({ theme }) => theme.spacing['3Xl']};
  margin-bottom: ${({ theme }) => theme.spacing['md']};
  span {
    line-height: ${({ theme }) => theme.spacing['3Xl']};
    margin-left: ${({ theme }) => theme.spacing['md']};
  }
`;

export const StyledPlainMessageWrapper = styled.div<{
  align: string;
  hasTopGutter: boolean;
}>`
  display: flex;
  word-break: break-word;
  flex-direction: ${({ align }) => (align === 'left' ? 'row' : 'row-reverse')};
  margin-top: ${({ hasTopGutter }) => (hasTopGutter ? ({ theme }) => theme.spacing['md'] : 0)};
`;

export const StyledSpacer = styled.div`
  max-width: 80%;
`;

export const StyledMessagesListBottomSpacer = styled.div`
  opacity: 0;
  height: 1px;
  min-height: 1px;
`;

export const StyledPlainTextContent = styled.div<{ align: string; contentWidth: string }>`
  background: ${({ align }) =>
    align === 'left'
      ? ({ theme }) => theme.background.weak
      : ({ theme }) => theme.background.strong};
  border-radius: ${({ theme }) => theme.borderRadius['xl']};
  max-width: ${({ contentWidth }) => contentWidth};
  padding: ${({ theme }) => theme.spacing['xl']};

  .bullet-item {
    text-align: left;
    display: flex;
    margin: ${({ theme }) => theme.spacing['md']} 0;
    padding: ${({ theme }) => theme.spacing['sm']} 0;
    :first-of-type {
      margin-top: ${({ theme }) => theme.spacing['lg']};
    }
    :last-of-type {
      margin-bottom: ${({ theme }) => theme.spacing['lg']};
    }
  }
  .bullet {
    margin: 0 ${({ theme }) => theme.spacing['md']};
  }
`;
